import { type FC, useEffect } from "react";

import { useGetProfile } from "@jti/rest-api";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import {
  fetchAccountContact,
  fetchAddresses,
  fetchOrderAttributes,
  fetchOrderDeliveryLimits,
} from "@jti/store/slices/LEGACY__checkoutSlice";
import { DEPRECATED_Loading } from "@jti/ui";

import { ShippingForm } from "@checkout/forms/ShippingForm";
import { useAgeVerification } from "@checkout/hooks/useAgeVerification";
import { useTrialBlockingCheckout } from "@checkout/hooks/useTrialBlockingCheckout";

import { AgeVerificationMessageBox } from "../../components/AgeVerificationMessageBox";
import { TrialBlockingCheckoutMessageBox } from "../TrialBlockingCheckoutMessageBox";

import styles from "./ShippingPageContent.module.scss";

type ShippingPageContentProps = {
  asideSubmitButtonWrapperRef: React.RefObject<HTMLDivElement | null>;
};

export const ShippingPageContent: FC<ShippingPageContentProps> = ({ asideSubmitButtonWrapperRef }) => {
  const dispatch = useDispatch();

  const { isAgeVerificationError } = useAgeVerification();
  const { isTrialBlockingCheckout } = useTrialBlockingCheckout();
  const addressesFetchStatus = useSelector((state) => state.checkout.addresses.fetchStatus);
  const profileDataFetchStatus = useSelector((state) => state.checkout.profileDataFetchStatus);
  const orderDeliveryLimitsFetchStatus = useSelector((state) => state.checkout.orderDeliveryLimits.fetchStatus);
  const orderAttributesFetchStatus = useSelector((state) => state.checkout.orderAttributes.fetchStatus);
  const { status: getProfileStatus } = useGetProfile();

  const isLoading =
    [addressesFetchStatus, profileDataFetchStatus, orderDeliveryLimitsFetchStatus, orderAttributesFetchStatus].includes(
      "pending"
    ) || ["loading", "idle"].includes(getProfileStatus);

  useEffect(() => {
    if (addressesFetchStatus === "idle") {
      dispatch(fetchAddresses());
    }
  }, [dispatch, fetchAddresses, addressesFetchStatus]);

  useEffect(() => {
    if (orderDeliveryLimitsFetchStatus === "idle") {
      dispatch(fetchOrderDeliveryLimits());
    }
  }, [dispatch, fetchOrderDeliveryLimits, orderDeliveryLimitsFetchStatus]);

  useEffect(() => {
    if (profileDataFetchStatus === "idle") {
      dispatch(fetchAccountContact());
    }
  }, [dispatch, profileDataFetchStatus, fetchAccountContact]);

  useEffect(() => {
    if (orderAttributesFetchStatus === "idle") {
      dispatch(fetchOrderAttributes(false));
    }
  }, [dispatch, fetchOrderAttributes, orderAttributesFetchStatus]);

  return (
    <div className={styles.container}>
      <AgeVerificationMessageBox isVisible={isAgeVerificationError} />

      <TrialBlockingCheckoutMessageBox isVisible={isTrialBlockingCheckout} />

      {isLoading ? <DEPRECATED_Loading /> : <ShippingForm asideSubmitButtonWrapperRef={asideSubmitButtonWrapperRef} />}
    </div>
  );
};
